import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Cover images — same originals used on /mas-alla-de-la-maternidad
const manantialCoverEs = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/5e469af3-5037-45ee-9cda-8014558ce15b_compressed_ChatGPT-Image-13-jul-2026-06_07_48-p.m..webp';
const reflejoCoverEs = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/1a45c953-d171-47b2-9bed-797a2011f3a5_compressed_ChatGPT-Image-13-jul-2026-06_07_08-p.m..webp';

const manantialCoverEn = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/b459f4c9-ed83-49c4-9915-20637e60e56a_compressed_2-EMI-TI-1.webp';
const reflejoCoverEn = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/e82083b7-fee3-47f2-8ebe-0c1c2eed7e06_compressed_1-ERL-T1.webp';

export default function MasAllaSection() {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  const manantialCover = isEnglish ? manantialCoverEn : manantialCoverEs;
  const reflejoCover = isEnglish ? reflejoCoverEn : reflejoCoverEs;

  return (
    <section id="mas-alla-maternidad" className="pt-14 md:pt-20 pb-20 md:pb-28 px-6 md:px-10 bg-background-50">
      <div className="w-full max-w-5xl mx-auto">

        {/* ── Encabezado introductorio ── */}
        <div className="mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-3">
            {t('mas_alla.section_main_title')}
          </h2>
          <p className="font-heading text-lg md:text-xl text-foreground-700 leading-tight mb-6">
            {t('mas_alla.section_subtitle')}
          </p>
          <p className="font-sans text-sm md:text-base text-foreground-700 leading-relaxed">
            {t('mas_alla.intro_p1')}
          </p>
          <p className="font-sans text-sm md:text-base text-foreground-700 leading-relaxed mt-3">
            {t('mas_alla.intro_p2')}
          </p>
          <p className="font-sans text-sm md:text-base text-foreground-700 leading-relaxed mt-3">
            {t('mas_alla.intro_p3')}
          </p>
          <p className="font-sans text-sm md:text-base text-foreground-700 leading-relaxed mt-3">
            {t('mas_alla.intro_p4')}
          </p>
          <p className="font-sans text-sm md:text-base text-foreground-700 leading-relaxed mt-3">
            {t('mas_alla.intro_p5')}
          </p>
          <p className="font-sans text-sm md:text-base text-foreground-700 leading-relaxed mt-3">
            <strong>{t('mas_alla.intro_mercedes')}</strong>
          </p>
        </div>

        {/* ── Libros — composición compacta y editorial, sin recuadros ── */}
        <div className="flex flex-col gap-10 md:gap-14 mb-16 md:mb-20">
          {/* Libro 1 — El Manantial Interior */}
          <article className="flex flex-col sm:flex-row gap-6 md:gap-10 items-start">
            <div className="w-[120px] sm:w-[130px] md:w-[150px] flex-shrink-0">
              <img
                src={manantialCover}
                alt={t('mas_alla.libro1_title')}
                className="w-full h-auto object-contain"
              />
            </div>
            <div className="flex-1 min-w-0">
              <span className="inline-block font-sans text-[11px] font-semibold text-terracotta uppercase tracking-[0.18em] mb-1.5">
                {t('mas_alla.libro1_subtitle')}
              </span>
              <h3 className="font-serif text-lg md:text-2xl font-bold text-[#8B6F5C] leading-snug mb-3">
                {t('mas_alla.libro1_title')}
              </h3>
              <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-4">
                {t('mas_alla.libro1_desc')}
              </p>
              <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
                <div className="flex items-baseline gap-1.5">
                  <span className="font-serif text-xl md:text-2xl font-bold text-[#8B6F5C]">$14.99</span>
                  <span className="font-sans text-xs text-[#5C4A3A]">USD</span>
                </div>
                <Link
                  to="/el-manantial-interior"
                  className="inline-flex items-center gap-2 bg-terracotta text-white px-5 py-2.5 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap"
                >
                  {t('mas_alla.conocer_mas')}
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </article>

          <div className="border-t border-background-200/60" />

          {/* Libro 2 — El Reflejo Luminoso */}
          <article className="flex flex-col sm:flex-row gap-6 md:gap-10 items-start">
            <div className="w-[120px] sm:w-[130px] md:w-[150px] flex-shrink-0">
              <img
                src={reflejoCover}
                alt={t('mas_alla.libro2_title')}
                className="w-full h-auto object-contain"
              />
            </div>
            <div className="flex-1 min-w-0">
              <span className="inline-block font-sans text-[11px] font-semibold text-terracotta uppercase tracking-[0.18em] mb-1.5">
                {t('mas_alla.libro2_subtitle')}
              </span>
              <h3 className="font-serif text-lg md:text-2xl font-bold text-[#8B6F5C] leading-snug mb-3">
                {t('mas_alla.libro2_title')}
              </h3>
              <p className="font-sans text-sm md:text-base text-[#3D2B1F] leading-relaxed mb-4">
                {t('mas_alla.libro2_desc')}
              </p>
              <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
                <div className="flex items-baseline gap-1.5">
                  <span className="font-serif text-xl md:text-2xl font-bold text-[#8B6F5C]">$14.99</span>
                  <span className="font-sans text-xs text-[#5C4A3A]">USD</span>
                </div>
                <Link
                  to="/el-reflejo-luminoso"
                  className="inline-flex items-center gap-2 bg-terracotta text-white px-5 py-2.5 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap"
                >
                  {t('mas_alla.conocer_mas')}
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </article>
        </div>

        {/* ── Corte visual decorativo hacia Timote ── */}
        <div className="mt-16 md:mt-20 flex items-center justify-center gap-4">
          <div className="h-px flex-1 bg-gradient-to-r from-transparent via-[#C58D72]/30 to-[#C58D72]/60" />
          <div className="flex items-center gap-2 px-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[#C58D72]/50" />
            <span className="w-1.5 h-1.5 rounded-full bg-[#C58D72]/70" />
            <span className="w-1.5 h-1.5 rounded-full bg-[#C58D72]/50" />
          </div>
          <div className="h-px flex-1 bg-gradient-to-l from-transparent via-[#C58D72]/30 to-[#C58D72]/60" />
        </div>

      </div>
    </section>
  );
}